<template>
	<div class="conversation-provider-manager">
		<span v-if="!oneProviderMode" class="card-title"
			>Conversation provider manager</span
		>
		<span v-else class="card-title clr-bg bgclr-secondary"
			>ThunderWave X
			<i>{{ getAllConversationProviders[0].name }}</i></span
		>
		<div class="conversation-provider-manager-outer">
			<div class="conversation-provider-manager-inner">
				<div v-if="usableConversationProviders.length == 0">
					<h4>
						There are no conversation providers currently available!
					</h4>
				</div>
				<div
					v-else-if="!oneProviderMode"
					class="provider-selector input-group"
				>
					<!-- <span class="input-group-addon">provider</span> -->
					<select
						class="provider-name input"
						v-model="providerName"
						title="provider name"
					>
						<option
							v-for="provider in usableConversationProviders"
							:key="provider.name ? provider.name : ''"
							:value="provider.name ? provider.name : ''"
							:disabled="
								provider.name &&
									!isAvailableProvider(provider.name)
							"
						>
							{{
								provider.name
									? provider.name
									: 'Please select a provider'
							}}
						</option>
					</select>
				</div>
				<div
					v-if="providerName"
					class="provider-manager-component-container"
				>
					<component
						v-if="curProviderManagerComponent"
						:is="curProviderManagerComponent"
					/>
				</div>
				<div v-else>
					<h4 style="padding: 0 .8rem;">
						Please select a conversation provider to start chatting
						:)
					</h4>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'ConversationProviderManager',
	data() {
		return {
			providerName: ''
		};
	},
	mounted() {
		this.$nextTick(() => {
			if (this.oneProviderMode) {
				this.providerName = this.usableConversationProviders[0].name;
			}
		});
	},
	computed: {
		usableConversationProviders() {
			let filtered = this.getAllConversationProviders.filter(provider => {
				return this.providerManagerComponent(provider.name);
			});
			if (!this.oneProviderMode) {
				filtered.unshift('');
			}
			return filtered;
		},
		curProviderManagerComponent() {
			return this.providerManagerComponent(this.providerName);
		},
		...mapGetters({
			isAvailableProvider: 'ConversationProviders/isAvailable',
			getAllConversationProviders:
				'ConversationProviders/getAllConversationProviders',
			oneProviderMode: 'ConversationProviders/oneProviderMode'
		})
	},
	methods: {
		providerManagerComponent(providerName) {
			if (providerName) {
				let component = this.$store.getters[
					'ConversationProviders/provider_' +
						providerName +
						'/managerComponent'
				];
				return component;
			}
			return null;
		}
	}
};
</script>
